import { render } from "./Testimonials3.vue?vue&type=template&id=bd82f968&scoped=true"
import script from "./Testimonials3.vue?vue&type=script&lang=js"
export * from "./Testimonials3.vue?vue&type=script&lang=js"

import "./Testimonials3.vue?vue&type=style&index=0&id=bd82f968&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bd82f968"

export default script